import React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import useMediaQuery from 'hooks/use-media-query';

const OfferSkeletonWrapper = styled.div`
  height: 298px;
  width: 146px;
  padding: 2px;
  ${Styles.desktop`
    height: 363px;
    width: 250px;
  `}
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 10%) 0px 2px 6px 0px;
`;

const OfferSkeletonContentWrapper = styled.div`
  padding: 16px 0;
`;

const OfferSkeletonWordsWrapper = styled.div`
  height: 108px;
  grid-template-rows: repeat(3, auto) 1fr;
  ${Styles.desktop`
    height: 85px;
    grid-template-rows: repeat(3, 1fr);
  `}
  display: grid;
  margin: 0 1rem 1rem 1rem;
`;

const OfferSkeletonButtonWrapper = styled.div`
  width: 114px;
  ${Styles.desktop`
    width: 218px;
  `}
  border-radius: 500px;
  margin: 0 auto;
  overflow: hidden;
`;

export const OfferSkeleton = () => {
  const isDesktop = useMediaQuery('desktop');
  return (
    <OfferSkeletonWrapper>
      <Skeleton height={isDesktop ? '163px' : '97px'} />
      <OfferSkeletonContentWrapper>
        <OfferSkeletonWordsWrapper>
          <Skeleton height="20px" />
          <Skeleton width="80%" height="20px" />
          <Skeleton width="40%" height="20px" />
        </OfferSkeletonWordsWrapper>
        <OfferSkeletonButtonWrapper>
          <Skeleton height={isDesktop ? '55px' : '34px'} />
        </OfferSkeletonButtonWrapper>
      </OfferSkeletonContentWrapper>
    </OfferSkeletonWrapper>
  );
};
